import Vue from 'vue';

/**
 * @author Duke
 *
 */
import zhLoading from './src/zhLoading.vue';

zhLoading.install = function (Vue) {
  Vue.component(zhLoading.name, zhLoading);
};

export default zhLoading;



// WEBPACK FOOTER //
// ./ui/zhloading/index.js